jQuery(document).ready(function () {
    if (Modernizr.touchevents) {
        // https://silviomoreto.github.io/bootstrap-select/methods/#selectpickermobile
        jQuery('.selectpicker').selectpicker('mobile');
    }
});



// WEBPACK FOOTER //
// ./private/js/bootstrap-select-mobile.js